/*!
 * Copyright (C) Octillion Media LLC 2019
 * All Rights Reserved.
 */
import { getActivityLogApi } from "../../helpers/api";

export const state = {
    activityLogList: [],
};

export const getters = {
    activityLogList: state => state.activityLogList,
};

export const mutations = {
    setActivityLogList(state, newValue) {
        state.activityLogList = newValue
    },
};

export const actions = {
    getActivityLog({commit}, payload) {
        getActivityLogApi(payload).then(res => {
            if(payload.live) {
                commit('setActivityLogList', res.data?.content);
                return;
            } else {
                 commit('setActivityLogList', res.data)
                return;
            }
        }, () => {
            commit('setActivityLogList', [])
        })
    },
    clearActivityLog({commit}) {
        commit('setActivityLogList', [])
    },
};
